import React from 'react';
import cx from 'classnames';

const Placeholder = ({animated = false, height = 2}) => (
  <div className={cx('Placeholder', {'Placeholder--animated': animated})}>
    {Array(height).fill().map(() => (
      <span className="Placeholder__line" />
    ))}
  </div>
);

export default Placeholder;
